import { Component, OnInit, Input } from '@angular/core';
import { IEUserAction, InterfaceElement } from 'src/app/model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { FormControl, FormGroup } from '@angular/forms';
import { UserActions } from '../../model/useraction/useractions';
import { UXControllerService } from 'src/app/service/controller/ux-controller.service';
import { CosyHtmlElementGenerationService } from 'src/app/service/generator/generator-html/cosy-html-element-generation.service';
import { InterfaceElementDefaults } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-default';
import { InterfaceElementTypes } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-type';
import { cloneDeep } from 'lodash-es';

@Component({
  selector: 'app-cosy-checkbox',
  templateUrl: './cosy-checkbox.component.html',
  styleUrls: ['./cosy-checkbox.component.css']
})
export class CosyCheckboxComponent implements OnInit {
  @Input() ie:InterfaceElement;
  @Input() formgroup:FormGroup = null;
  @Input() label:boolean = false;
  @Input() nullValue:boolean = false;
  @Input() RTKeyShowNullable:boolean = false;

  private ua: IEUserAction ;
  private cloneIE: InterfaceElement;


  constructor(private uxControllerService: UXControllerService, private cosyHtmlElementGenerationService: CosyHtmlElementGenerationService) { }

  ngOnInit() {
    this.cloneIE =  cloneDeep(this.ie);
    if (this.nullValue)
    {
     
      if (this.ie.Values[0].nil == true) {
        this.formgroup.get(this.ie.InterfaceElementID).setValue('');
        this.formgroup.get(this.ie.InterfaceElementID).disable();
      } 
    }

    this.ua = new IEUserAction();

    if (this.ie.UserActions == null) {
      this.ie.UserActions = [];
    }
    if (this.ie.Attributes.OnChangeUAID == null) {
      this.ua = this.cosyHtmlElementGenerationService.generateInlineUAID(this.ie.TypeDID, null);
      this.ie.UserActions.push(this.ua);
      this.ie.Attributes.OnChangeUAID = this.ua.UserActionID;
    } 
  }

  fetchIEUserAction(userActionID: string, value: any, attributeKey: string, additionalAttributes: any[], additionalInterfaceElements: InterfaceElement[], formgroup:FormGroup, multiselect:boolean) {
   

    if (userActionID == null) {
      userActionID = this.ie.Attributes.OnSelectUAID;
    }
    if (userActionID != null) {
      if (this.nullValue)
      {
        if (value) {
          this.formgroup.get(this.ie.InterfaceElementID).setValue('');
          this.formgroup.get(this.ie.InterfaceElementID).disable();
          this.updateFormControlsForNonFormElements(this.cloneIE, value);
        }
        else {
        if (userActionID == UserActions.GetSelectedUA) this.formgroup.get(this.ie.InterfaceElementID).setValue(InterfaceElementDefaults.InputPicklistDefault);
          this.formgroup.get(this.ie.InterfaceElementID).enable();
          this.formgroup.get(this.ie.InterfaceElementID).markAsTouched();    
          this.updateFormControlsForNonFormElements(this.cloneIE, value);     
        }
        value = 'nil' + value;
      }
      
      this.uxControllerService.fetchIEUserAction(userActionID, 
        this.ie, 
        value, 
        attributeKey, 
        additionalAttributes, 
        additionalInterfaceElements, 
        formgroup, 
        multiselect);
    }
  }

  updateFormControlsForNonFormElements(interfaceElement :InterfaceElement, value){
    let selectedValue: any = '';
    if(interfaceElement.TypeDID == InterfaceElementTypes.InputPicklist&& interfaceElement.CustomizeOptions!= null && interfaceElement.CustomizeOptions.Multiple == 'multiple'){
      
      if(value){
        this.formgroup.get(interfaceElement.InterfaceElementID+'_alle').disable();
        this.formgroup.get(interfaceElement.InterfaceElementID+'_alle').setValue('');

        for(let dmd of interfaceElement.DynamicMetaData.Items){
          this.formgroup.get(dmd.ID).disable();
          this.formgroup.get(dmd.ID).setValue('');
        }
      }
      else {
        this.formgroup.get(interfaceElement.InterfaceElementID+'_alle').enable();
        for(let dmd of interfaceElement.DynamicMetaData.Items){
          this.formgroup.get(dmd.ID).enable();
          this.formgroup.get(dmd.ID).markAsTouched();
          /*for(let val of interfaceElement.Values){
            if(val.Value == dmd.ID){
              selectedValue = dmd.ID;
              this.formgroup.get(dmd.ID).setValue(val.Checked);
              this.formgroup.get(dmd.ID).markAsTouched();
            }
          }*/
        }
        this.formgroup.get(interfaceElement.InterfaceElementID).enable();
        this.formgroup.get(interfaceElement.InterfaceElementID).markAsTouched();
        this.formgroup.get(interfaceElement.InterfaceElementID).setValue(selectedValue);
      }
    }

  }
}
